import script from "./ModalEntrelacos.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalEntrelacos.vue?vue&type=script&setup=true&lang=js"

import "./ModalEntrelacos.vue?vue&type=style&index=0&id=e5230c1a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5230c1a"]])

export default __exports__